'use client'

import { useEffect } from 'react'

import { useGlobalConfigContext } from '../../global-config'
import { gtmDataLayerPush } from '../../gtm'
import { getContext } from '../gtm/events/loginRegistrationGtmPushFullStoryPayload.ts'

export const useLoginRegistrationRegistrationGtmPushFullStoryTracking = (
  isOpen: boolean,
): void => {
  const config = useGlobalConfigContext()

  useEffect(() => {
    if (!isOpen) {
      return
    }

    const referrer = typeof document === 'undefined' ? '' : document.referrer
    const context = getContext({
      config,
      url: referrer,
    })

    gtmDataLayerPush({
      event: 'fs_page_prop',
      fs_page_properties: {
        context,
        pageName: 'register',
      },
    })
  }, [config, isOpen])
}
